import { cn, Text } from '@bridebook/aura';

export type SliderTooltipProps = {
  children: React.ReactNode;
  disabled?: boolean;
  classNames?: {
    wrapper?: string;
    bubble?: string;
    chevron?: string;
  };
};

export const SliderTooltip = ({ children, disabled, classNames }: SliderTooltipProps) => (
  <span className={cn('flex flex-col items-center', classNames?.wrapper)}>
    <span
      className={cn(
        'rounded bg-white px-2 py-1',
        disabled ? 'bg-space-04' : 'bg-white shadow-bb-shadow',
        classNames?.bubble,
      )}>
      <Text
        className={cn(
          'typo-sm-semibold whitespace-nowrap',
          disabled ? 'text-space-60' : 'text-space',
        )}>
        {children}
      </Text>
    </span>
    <span
      className={cn(
        '-mt-1 block h-2 w-2 rotate-45 rounded-[1px] bg-white',
        disabled ? 'bg-space-04' : 'bg-white',
        classNames?.chevron,
      )}
    />
  </span>
);
